import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=20154c82"
import script from "./FilterMenu.vue?vue&type=script&lang=js"
export * from "./FilterMenu.vue?vue&type=script&lang=js"
import style0 from "./FilterMenu.vue?vue&type=style&index=0&id=20154c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports